<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>

        <transition name="fade-fast" mode="out-in">
        <div v-if="loading" key="loading">
            <busy-spinner inner-class="my-5"></busy-spinner>
        </div>
        <div v-else key="loaded">
            <div v-if="reqCriteria.length > 0" class="p-3 border rounded bg-gray-50 mb-4 animate__animated animate__fadeIn">
                <h4>Minimum Qualifications</h4>
                <p class="text-muted">Minimum requirements that must be met for a vendor to be considered.</p>
                <div>
                    <div v-for="req in reqCriteria" :key="req.id" class="mb-1">
                        <b-icon icon="square" class="mr-2"></b-icon>
                        {{ req.name }}
                    </div>
                </div>
            </div>
            <div v-if="reqCriteria.length > 0" class="p-3 border rounded bg-gray-50 mb-4">
                <h4>Scoring Criteria</h4>
                <p class="text-muted mb-0">Decision criteria we will use to assign objective scores to each response.</p>
                <div class="p-3">
                    <div v-for="group in scoringCriteria" :key="group.id" class="border-bottom py-3">
                        <div class="d-flex justify-content-between mb-2">
                            <h5 class="mb-0">{{ group.name }}</h5>
                            <div>
                                <span class="special-text text-muted mr-3">Group weight:</span>
                                <span class="font-weight-bold">{{ group.weight }}%</span>
                            </div>
                        </div>
                        <div>
                            <div v-for="item in group.items" :key="item.id" class="d-flex justify-content-between mb-1">
                                <div>
                                    <span class="mr-3">{{ item.name }}</span>
                                    <b-badge v-if="item.rating_type === 'FIVE'" variant="soft-info">5-point Scale</b-badge>
                                    <b-badge v-if="item.rating_type === 'BINARY'" variant="soft-accent">Yes / No</b-badge>
                                </div>
                                <div class="text-muted">
                                    {{ item.weight * (group.weight / 100) }}%
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between pt-3">
                        <h5 class="mb-0"></h5>
                        <div class="font-weight-bold">
                            <span class="special-text mr-3">Total weight:</span>
                            100%
                        </div>
                    </div>
                </div>
                <!-- <pre>{{ scoringCriteria }}</pre> -->
            </div>
        </div>
        </transition>

    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
import cloneDeep from 'lodash/cloneDeep';
import { buildNestedCriteria } from '../js/scoring-criteria';

export default {
    name: 'VendorRfxCriteriaList',
    components: {},
    props: {
        rfxId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: true,  // starting as true to make things less jumpy
            reqCriteria: [],  // put here after getting from API
            scoringCriteria: [],  // put here after getting from API and building nested list
            criteriaFromApi: [],  // raw from API, not nested
        }
    },
    computed: {

    },
    mounted: function() {
        this.getCriteria();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        setLocalData: function(respData) {
            // takes raw data from API and splits it into local data on this component
            let apiData = cloneDeep(respData);
            let processedCriteria = buildNestedCriteria(apiData.criteria_list);  // criteria_list is the flat array of criteria from API
            this.reqCriteria = processedCriteria.requirements;
            this.scoringCriteria = processedCriteria.scoring;
        },
        getCriteria: function() {
            // get list of criteria from api
            this.loading = true;
            return suppliosApi.rfx.listCriteria(this.rfxId)
            .then(response => {
                this.setLocalData(response.data);
                return true;
            })
            .catch(error => {
                this.handleError(error, 'Error while getting criteria from API');
                return false;
            })
            .then((wasSuccess) => {
                this.loading = false;
                return wasSuccess;
            })
        }

    }
}
</script>

<style>

</style>